module.exports = __webpack_public_path__ + "img/copper_normal.5b703620.png";